/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";

//*************** Libreria para realizar pdfs************************************* */
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

// ------------------ COMPONENTES DE BASE--------------------------
import Loader from "../../../Base/Components/Loader/Loader";
import { getInformacionEmpresa } from "../../../Base/API/Global/InformacionEmpresa/InformacionEmpresaRequest";
import { getLabel } from "../../../Base/Services/Language/LanguageService";

// ------------------- CONSULTAS A LA API---------------------------
import { getDetallesOrdenPorId, getEncabezadoOrdenPorId } from "../../../API/Ventas/SalesOrdersRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------

import QRCode from "qrcode";
import { logoCSMBase64 } from "../../../utils/Imagenes/Imgs";
import { SalesOrdersLang } from "./SalesOrdersLang";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const SalesOrderReporte = ({
  showDialogReporte,
  setShowDialogReporte,
  selectedEnc,
  getInfo,
  Language
}) => {
  const [loading, setLoading] = useState(true);
  const [pdfReporte, setPdfReporte] = useState([]);
  const toast = useRef(null);

  const obtenerInformacion = async () => {
    setLoading(true);
    let IdSalesOrderEnc = selectedEnc[0]?.IdSalesOrderEnc;

    if (IdSalesOrderEnc) {
      const encabezadoTempo = await getEncabezadoOrdenPorId(IdSalesOrderEnc);
      const detallesTempo = await getDetallesOrdenPorId(IdSalesOrderEnc);
      const infoEmpresaTempo = await getInformacionEmpresa();
      generarPDF(encabezadoTempo[0], detallesTempo, infoEmpresaTempo[0]);
    }
    setLoading(false);
  };

  const generarPDF = async (encabezado, detalles, infoEmpresa) => {
    setLoading(true);
    let CodigoQR;
    const fechaHoraActual = new Date().toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      });

    QRCode.toDataURL(
      `${encabezado?.NoOrden || ""}`,
      { errorCorrectionLevel: "Q" },
      (err, url) => {
        CodigoQR = url;
      }
    );

    const totalSubTotalL = detalles.reduce((sum, d) => sum + (Number(d.SubTotalL) || 0), 0);
    const totalSubTotalD = detalles.reduce((sum, d) => sum + (Number(d.SubTotalD) || 0), 0);

    const docDefinition = {
      pageSize: "LETTER",
      pageOrientation: "portrait",
      pageMargins: [39, 105, 39, 60],

      // HEADER
      header: function (currentPage, pageCount, pageSize) {
        return {
          table: {
            widths: ["29%", "51%", "20%"],
            body: [
              [
                {
                  image: logoCSMBase64.logo,
                  width: 190,
                  rowSpan: 2,
                },
                {
                  text: infoEmpresa?.NombreLegal || "",
                  margin: [0, 30, 0, 0],
                  style: "titulo",
                },
                {
                  text: encabezado?.NoOrden || "",
                  style: "noOrden",
                  margin: [-5, 15, 0, 0],
                },
              ],
              [
                {},
                {
                  text: infoEmpresa?.Direccion || "",
                  style: "titulo2",
                },
                {
                  image: CodigoQR,
                  width: 70,
                  margin: [0, -15, 0, 0],
                },
              ],
            ],
          },
          layout: "noBorders",
        };
      },

      //   FOOTER
      footer: (currentPage, pageCount) => {
        return {
          margin: [35,0,35,0],
          layout: "noBorders",
          table: {
            widths: ['*','*'],
            body: [
              [
                {
                  text: `${getLabel( SalesOrdersLang, "fechaImpresion", Language)} ${fechaHoraActual}`,
                  style: 'footer',
                },
                {
                  style: 'footerRight',
                  text: `${getLabel( SalesOrdersLang, "Pagina", Language )} ${currentPage} / ${pageCount}`,
                },
              ],
            ],
          },
        };
      },

      // CONTENIDO
      content: [
        {
          text: `${getLabel(SalesOrdersLang, "TituloReporte", Language)}`,
          style: "tituloReporte",
          margin: [0, -10, 0, 0],
        },
        {
          table: {
            widths: ["*", "*"],
            body: [
              [
                {
                  text: [
                    {
                      text: `${getLabel(SalesOrdersLang, "fecha", Language)}: `,
                      style: "headerBold",
                    },
                    {
                      text: `${encabezado?.DateCreateStr || ""}`,
                      style: "headerNoBold",
                    },
                  ],
                },
                {
                  text: [
                    {
                      text: `${getLabel(
                        SalesOrdersLang,
                        "estado",
                        Language
                      )}: `,
                      style: "headerBold",
                    },
                    {
                      text: `${encabezado?.StatusName || ""}`,
                      style: "headerNoBold",
                    },
                  ],
                },
              ],
              [
                {
                  text: [
                    {
                      text: `${getLabel(
                        SalesOrdersLang,
                        "customerOrder",
                        Language
                      )}: `,
                      style: "headerBold",
                    },
                    {
                      text: `${encabezado?.CustomerOrder || ""}`,
                      style: "headerNoBold",
                    },
                  ],
                },
                {
                  text: [
                    {
                      text: `${getLabel(
                        SalesOrdersLang,
                        "agente",
                        Language
                      )}: `,
                      style: "headerBold",
                    },
                    {
                      text: `${encabezado?.UserNameAgent || ""}`,
                      style: "headerNoBold",
                    },
                  ],
                },
              ],
              [
                {
                  text: [
                    {
                      text: `${getLabel(
                        SalesOrdersLang,
                        "cliente",
                        Language
                      )}: `,
                      style: "headerBold",
                    },
                    {
                      text: `${encabezado?.CustomerName || ""}`,
                      style: "headerNoBold",
                    },
                  ],
                },
                {
                  text: [
                    {
                      text: `${getLabel(SalesOrdersLang, "Buyer", Language)}: `,
                      style: "headerBold",
                    },
                    {
                      text: `${encabezado?.CompanyName || ""}`,
                      style: "headerNoBold",
                    },
                  ],
                },
              ],
              [
                {
                  text: [
                    {
                      text: `${getLabel(
                        SalesOrdersLang,
                        "terminoEnvio",
                        Language
                      )}: `,
                      style: "headerBold",
                    },
                    {
                      text: `${encabezado?.TerminoEnvio || ""}`,
                      style: "headerNoBold",
                    },
                  ],
                },
                {
                  text: [
                    {
                      text: `${getLabel(
                        SalesOrdersLang,
                        "terminoVenta",
                        Language
                      )}: `,
                      style: "headerBold",
                    },
                    {
                      text: `${encabezado?.TerminoVenta || ""}`,
                      style: "headerNoBold",
                    },
                  ],
                },
              ],
            ],
          },
          layout: "noBorders",
          margin: [0, 10, 0, 0],
        },
        //DETALLES
        {
          table: {
            widths: ["55%", "12%", "10%", "10%", "15%"],
            body: [
              [
                {
                  text: `${getLabel(SalesOrdersLang, "yarn", Language)}`,
                  style: "headerTable",
                },
                {
                  text: `${getLabel(
                    SalesOrdersLang,
                    "fechaExportancion",
                    Language
                  )}`,
                  style: "headerTable",
                },
                {
                  text: `${getLabel(SalesOrdersLang, "Cantidad", Language)}`,
                  style: "headerTable",
                },
                {
                  text: `${getLabel(SalesOrdersLang, "PrecioL", Language)}`,
                  style: "headerTable",
                },
                {
                  text: `${getLabel(SalesOrdersLang, "SubTotalL", Language)}`,
                  style: "headerTable",
                },
              ],
              ...detalles.map((d) => [
                {
                  text: `${d?.Yarn || ""}`,
                  style: "infoGeneral",
                  margin: [0, 3, 0, 0],
                },
                {
                  text: `${d?.ExportDate?.split(" ")[0]}`,
                  style: "infoGeneralCenter",
                  margin: [0, 3, 0, 0],
                },
                {
                  text: `${
                    Number(d.Quantity || 0).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) || ""
                  } ${d?.UnitSimbol}`,
                  style: "infoGeneralRight",
                  margin: [0, 3, 0, 0],
                },
                {
                  text: `L ${Number(d.PrecioL || 0).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`,
                  style: "infoGeneralRight",
                  margin: [0, 3, 0, 0],
                },
                {
                  text: `L ${
                    Number(d.SubTotalL || 0).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) || ""
                  }`,
                  style: "infoGeneralRight",
                  margin: [0, 3, 0, 0],
                },
              ]),
              [
                {
                  text: `${detalles?.length || 0}`,
                  style: "headerTable",
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "headerTable",
                },
                {
                  text: ``,
                  style: "headerTable",
                },
                {
                  text: ``,
                  style: "headerTable",
                },
                {
                  text: `L ${Number(totalSubTotalL || 0).toLocaleString(
                    "en-US",
                    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                  )}`,
                  style: "headerTable",
                  alignment: "right",
                  margin: [0, 5, 0, 0],
                },
              ],
            ],
          },
          layout: "lightHorizontalLines",
          margin: [0, 15, 0, 0],
        },

        //TOTALES
        {
          margin: [0, 30, 0, 0],
          table: {
            widths: ["70%", "16%", "16%"],
            body: [
              [
                {
                  text: [
                    {
                      text: `${getLabel(
                        SalesOrdersLang,
                        "comentario",
                        Language
                      )}: `,
                      style: "headerBold",
                    },
                    {
                      text: `${encabezado?.Comentario || ""}`,
                      style: "headerNoBold",
                    },
                  ],
                  rowSpan: 2,
                  border: [false, false, false, false],
                },
                {
                  text: `${getLabel(SalesOrdersLang, "Sub Total L", Language)}`,
                  style: "headerBoldRight",
                },
                {
                  text: `L ${Number(totalSubTotalL || 0).toLocaleString(
                    "en-US",
                    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                  )}`,
                  style: "infoGeneralRight",
                },
              ],
              [
                {},
                {
                  text: `${getLabel(SalesOrdersLang, "Sub Total $", Language)}`,
                  style: "headerBoldRight",
                },
                {
                  text: `$ ${Number(totalSubTotalD || 0).toLocaleString(
                    "en-US",
                    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                  )}`,
                  style: "infoGeneralRight",
                },
              ],
            ],
          },
        },
      ],

      // ESTILOS
      styles: {
        titulo: {
          fontSize: 10,
          bold: true,
          alignment: "left",
        },
        titulo2: {
          fontSize: 10,
          alignment: "left",
        },
        noOrden: {
          fontSize: 12,
          bold: true,
          alignment: "justify",
        },
        tituloReporte: {
          fontSize: 12,
          bold: true,
          alignment: "center",
        },
        headerBold: {
          fontSize: 9,
          bold: true,
          alignment: "left",
        },
        headerNoBold: {
          fontSize: 9,
          alignment: "left",
        },
        headerTable: {
          fontSize: 8,
          alignment: "center",
          bold: true,
        },
        infoGeneral: {
          fontSize: 8,
        },
        infoGeneralCenter: {
          fontSize: 8,
          alignment: "center",
        },
        infoGeneralRight: {
          fontSize: 8,
          alignment: "right",
        },
        headerBoldRight: {
          fontSize: 9,
          bold: true,
          alignment: "right",
        },        
        footer: {
            fontSize: 8,
            alignment: "left",
        },
        footerRight: {
            fontSize: 8,
            alignment: "right",
        },
      },
    };

    const doc = pdfMake.createPdf(docDefinition);

    doc.getDataUrl((url) => {
      setPdfReporte(url);
    });
    setLoading(false);
  };

  useEffect(() => {
    if (showDialogReporte) {
      obtenerInformacion();
    }
  }, [showDialogReporte]);

  const onHideReporte = () => {
    setShowDialogReporte(false);
    getInfo();
    // setLanguaje("es");
  };

  return (
    <Dialog
      visible={showDialogReporte}
      onHide={onHideReporte}
      style={{ width: "63vw", height: "85vh" }}
    >
      <Loader loading={loading} />
      <Toast ref={toast} />
      <div>
        {!loading && pdfReporte && (
          <iframe
            src={pdfReporte}
            style={{ width: "60vw", height: "75vh", border: "1px solid #ccc" }}
            id="foo"
            title="Reporte QR PDF"
          />
        )}
      </div>
    </Dialog>
  );
};

export default SalesOrderReporte;
